import React, { useState } from "react";
import { API_URL } from "./config";
import {
  Container,
  Typography,
  Paper,
  Box,
  TextField,
  Button,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function ResetPasswordToken() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const res = await fetch(`${API_URL}/auth/reset-password-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, new_password: newPassword }),
      });
      const data = await res.json();
      if (!res.ok) {
        if (data?.data?.error?.message?.detail) {
          throw new Error(data.data.error.message.detail);
        } else if (data?.error?.message?.detail) {
          throw new Error(data.error.message.detail);
        } else if (data?.detail) {
          throw new Error(data.detail);
        } else if (data?.message) {
          throw new Error(data.message);
        }
        throw new Error('Password reset failed. Please try again.');
      }
      setSuccess("Password reset successful. You can now log in.");
      setTimeout(() => navigate("/signin"), 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xs" sx={{ pt: 8 }}>
      <Paper sx={{ p: 4, mt: 14, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={600} mb={2} align="center">
          Reset Your Password
        </Typography>
        <form onSubmit={handleReset}>
          <TextField
            label="New Password"
            type="password"
            fullWidth
            margin="normal"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">{success}</Alert>}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2, fontWeight: 600 }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Reset Password"}
          </Button>
        </form>
      </Paper>
    </Container>
  );
}
